<ng-container>
	<dodo-base-header></dodo-base-header>
	<div class="container">
		<div class="payment-header">Payment</div>
	</div>
	<div>
		<div class="container">
			
			<h3 id="for-desktop">
				Please enter your details below<br />
				so we can find your order.
			</h3>
			<h3 id="for-mobile">
				Please enter your details below so we can find your order.
			</h3>
		</div>
		<form [formGroup]="_form" class="form-payment">
			<tc-input-form-field class="payment-control"
				controlName="reference"
				label="Reference Id"
				[required]="true"
				[maxLength]="8"
				[appearance]="_appearance"
			></tc-input-form-field>
		</form>
		<div class="form-payment">
			<div class="action next-button">
				<dodo-raised-button
					[class.disabled]="false"
					id="next"
					color="accent"
					[disabled]="false"
					(clicked)="gotoPayment()"
				>
					Next
				</dodo-raised-button>
			</div>
		</div>
	</div>
</ng-container>
	